module.exports = __webpack_public_path__ + "img/slide-3-desk-min.7e1b6809.jpg";